import React from 'react';
import { Outlet } from 'react-router-dom';

const FilesHome = () => {
    return (
      <section className="app-route">
        <Outlet />
      </section>
    );
};

export default FilesHome;
